export default {
  "list": "_list_qk8xw7"
};